import NativeMaterialScrollTop from './components/native-material-scrolltop'
import NativeSlider from './components/native-slider'

export default {
  initializerOpts: {
    mountedModulePrefix: '__'
  },
  modules: {
    nativeMaterialScrollTop: {
      module: NativeMaterialScrollTop,
      listenerOpts: { passive: true }
    },
    nativeSlider: {
      module: NativeSlider
    }
  }
}
